import React from "react";
import "./About.css";

const About: React.FC = () => {
  return (
    <section id="about" className="about">
      <div className="about-container">
        <div className="about-image">
          <img
            src="/profile.png"
            alt="Roxanne - Educator and Tutor"
            className="profile-photo"
          />
        </div>
        <div className="about-content">
          <h2>About Roxanne</h2>
          <p>
            Roxanne brings 18 years of teaching experience and academic training
            that spans education, law, and child psychology. With a B.A. from
            UCLA, a J.D. from Pepperdine Law, and graduate coursework in child
            psychology from Columbia, she develops higher-order thinking skills
            in students—analytical reasoning and critical thinking that sets
            them apart along their academic and professional trajectory.
          </p>
          <p>
            Through her legal training, she brings a distinctive edge to
            teaching critical thinking, analytical reasoning, and argumentative
            writing. Roxanne is a credentialed teacher drawn to one-on-one
            work—the chance to truly see a student, understand what they need,
            and meet them there. She works with students from Pre-K through
            college, offering everything from foundational literacy to advanced
            analytical writing. She helps students become strong, clear thinkers
            who can express themselves with confidence and in their own
            authentic voice.
          </p>
          <p>
            Sessions are available in person in the South Bay and Los Angeles
            area, or remotely for families anywhere.
          </p>
          <p className="about-closing">
            I welcome the opportunity to discuss how I can support your
            child's learning.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
